import { QueryResult } from 'react-apollo';
import styled from 'styled-components';
import gql from 'graphql-tag';

import { themes } from 'kb-shared';

export type Lab = {
  id: string;
  name: string;
  stripePublicKey: string;
};

export type LabsQuery = QueryResult<{
  labs: Array<Lab>;
}>;

export const InputContainer = styled.div`
  max-width: 400px;
  flex: 1;
`;

export const VMarginWrapper = styled.div`
  margin: 20px 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
`;

export const TwoFieldWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

export const InputWrapperMargin = styled.div`
  flex: 1;
  :first-child {
    margin-right: 10px;
    max-width: 50%;
  }
  :last-child {
    margin-left: 10px;
    max-width: 50%;
  }

  input[name='phone'][type='default']::placeholder {
    font-size: 0.7em;
  }
`;

export const DisclaimerText = styled.p`
  ${themes.fonts.FoundersGrotesk};
  font-size: 12px;
  font-style: italic;
`;

export const GenderInputWrapper = styled(InputWrapperMargin)`
  min-width: 110px;
`;

export const sortLabs = (a: Lab, b: Lab) => {
  // equal items sort equally
  if (a.name === b.name) {
    return 0;
  }
  // Other sort after anything else
  else if (a.name === 'Other') {
    return 1;
  } else if (b.name === 'Other') {
    return -1;
  }
  // otherwise lowest sorts first
  else {
    return a.name < b.name ? -1 : 1;
  }
};

export const QUERY_LABS = gql`
  query labs {
    labs {
      id
      name
      stripePublicKey
    }
  }
`;
